export default "__VITE_ASSET__xvDERmlC__"